module.exports = __webpack_public_path__ + "static/guardian-e5cfcc03b769fe3871af6d3be02d48f7.svg";